<div class="sign-up-page">
  <div class="container-fluid">

    <div class="row">
      <div class="col-12 right-side" *ngIf="!signUpSuccess">
        <achoo-placeholder [placeholderId]="'loginComponentHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="true">
          <sign-up-form (signUpSuccessCallback)="afterSignUpSuccess($event)"></sign-up-form>
        </achoo-placeholder>
      </div>
      
      <div class="col-12 right-side" *ngIf="signUpSuccess">
        <div class="d-flex flex-column flex-auto align-items-center justify-content-center success-box">
          <p class="text-center app-logo"><img src="{{ 'APP.LOGO' | translate }}" width="300" alt="logo"/></p>
          <p class="success-msg">{{'sign_up.success' | translate}}</p>
          <p *ngIf="!isInvited" class="verify-email">{{'sign_up.verify_email' | translate}}</p>

          <p class="d-flex flex-row login-link">
            <span>{{'sign_up.click' | translate}}</span>
            <a [routerLink]="['/login']" class="underline-link">{{'sign_up.here' | translate}}</a>
            <span>{{'sign_up.login_ready' | translate}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/sign-up/sign-up.component.html